import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useShoppingCart } from '../context/ShoppingCartProvider';
import { Money } from 'shared/build/Money';
import { Button, ButtonColorSchema } from 'ui-components/build';
import { FullscreenSpinner } from '../components/FullscreenSpinner';
import { useHistory } from 'react-router-dom';
import { useAuthentication } from '../context/AuthenticationProvider';
import { ItemsTable } from '../components/ItemsTable';
import { useQueryCache } from 'react-query';

const ScIntroSentence = styled.h4`
  margin: 0 0 10px 0;
`;

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScButtonOrder = styled(Button)`
  align-self: flex-end;
`;

const ScActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  button:first-child {
    margin-right: 20px;
  }
`;

export const Cart = () => {
  const { shoppingCart, removeItem } = useShoppingCart();
  const { user } = useAuthentication();
  const history = useHistory();
  const queryCache = useQueryCache();

  const [total, setTotal] = useState<Money>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!user) return undefined;

    const total: Money = Object.values(shoppingCart.items).reduce(
      (acc, item) => {
        return acc.add(item.unitPrice.multiply(item.quantity));
      },
      new Money(0, user.currency)
    );

    setTotal(total);
  }, [shoppingCart, user]);

  if (!user) return null;

  return (
    <ScWrapper className="babys-page-padding babys-page-min-size">
      <FullscreenSpinner show={loading} />
      <ScIntroSentence className="babys-cursive">
        Estes são os presentes...
      </ScIntroSentence>
      <ItemsTable
        currency={user.currency}
        items={Object.values(shoppingCart.items)}
        actions={[
          {
            text: 'Remover',
            onClick: async (productId) => {
              setLoading(true);
              await removeItem(productId);
              queryCache.removeQueries(['website-product-get', productId]);
              setLoading(false);
            },
          },
        ]}
      />
      <ScActions>
        <ScButtonOrder
          onClick={() => {
            history.push('/inicio');
          }}
        >
          Escolher mais Presentes
        </ScButtonOrder>
        <ScButtonOrder
          disabled={!total || total.amount <= 0}
          colorSchema={ButtonColorSchema.primary}
          onClick={() => {
            history.push('/checkout');
          }}
        >
          Ir ao Pagamento
        </ScButtonOrder>
      </ScActions>
    </ScWrapper>
  );
};
